// The 5 public Showcase Blueprints — fully viewable by anyone (no blur, no signup).
// Reports are guaranteed to exist in every environment via backend/showcase_seed.json.
// Regenerated Oct 2026 under evidence-integrity rules (archived scan inputs, no unsupported precision).
export const SHOWCASE = [
  {
    id: "d45d1bd3-fe64-4b23-a312-90ec4a43febb",
    name: "NFL",
    flag: "🇺🇸",
    tag: "Powerhouse",
    domain: "nfl.com",
    topPlay: "Sponsorships",
    score: 92,
    teaser: "$500K–$5M+ per annual sponsor — plus 3 more scored plays.",
  },
  {
    id: "df19212e-92d0-4d6f-946e-457314aeb8f1",
    name: "GlossLink",
    flag: "🚀",
    tag: "Indie app",
    domain: "glosslink.app",
    topPlay: "Freemium",
    score: 92,
    teaser: "A $9.99/mo freemium ladder plus team deals, mapped step by step.",
  },
  {
    id: "e1167765-b6dd-4d87-adf1-62f23634be4b",
    name: "LEGO",
    flag: "🇩🇰",
    tag: "Powerhouse",
    domain: "lego.com",
    topPlay: "Subscriptions",
    score: 89,
    teaser: "A subscription play modeled to $24M ARR — plus 3 more plays.",
  },
  {
    id: "ba43f2be-e545-4976-a876-7282ee3f0318",
    name: "Emergent",
    flag: "🤖",
    tag: "AI platform",
    domain: "emergent.sh",
    topPlay: "Affiliate",
    score: 87,
    teaser: "$50–150 MRR per referred customer across 5 scored plays.",
  },
  {
    id: "7cb47741-453c-4de1-90ee-98404a802a66",
    name: "Chick-fil-A",
    flag: "🇺🇸",
    tag: "Powerhouse",
    domain: "chick-fil-a.com",
    topPlay: "App Purchases",
    score: 72,
    teaser: "$3–8 per active app subscriber — honest scores, no inflation.",
  },
];

export const SHOWCASE_REPORT_IDS = SHOWCASE.map((s) => s.id);
